import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function OnboardingDataUserSchema() {
  const { t } = useTranslation('validation');

  return z.object({
    document: z.string().min(1, t('notEmpty')),
    name: z.string().min(1, t('notEmpty')),
    fantasyName: z.string().optional(),
    postalCode: z.string().min(1, t('notEmpty')),
    number: z.string().min(1, t('notEmpty')),
    complement: z.string(),
    phone: z.string().min(1, t('notEmpty')),
    email: z.string().min(1, t('notEmpty')),
    street: z.string().min(1, t('notEmpty')),
    district: z.string().min(1, t('notEmpty')),
    city: z.string().min(1, t('notEmpty')),
    state: z.string().min(1, t('notEmpty')),
    genre: z.string().min(1, t('notEmpty')),
    birthDate: z.string().min(1, t('notEmpty')),
  });
}

export type IOnboardingDataUserForm = z.infer<
  ReturnType<typeof OnboardingDataUserSchema>
>;
